export default __webpack_public_path__ + "media/images/casatb/about_us/landscape-28edea209c34ebbc97381e74d85f4648.png";